import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomTranscriptOutlined = createSvgIcon(
  <path d="M13.786 3c.58 0 1.071.485 1.071 1.06 0 .617-.491 1.058-1.071 1.058H3.07C2.446 5.118 2 4.677 2 4.06 2 3.485 2.446 3 3.07 3zm7.143 5.216c.58 0 1.071.485 1.071 1.06 0 .617-.491 1.058-1.071 1.058H3.07c-.624 0-1.07-.441-1.07-1.059a1.05 1.05 0 0 1 1.071-1.059H20.93ZM2 14.754c0-.574.446-1.06 1.071-1.06h10.715c.58 0 1.071.486 1.071 1.06 0 .617-.49 1.059-1.071 1.059H3.07c-.625 0-1.071-.442-1.071-1.06Zm18.929 4.128c.58 0 1.071.485 1.071 1.059 0 .618-.491 1.059-1.071 1.059H3.07C2.446 21 2 20.559 2 19.94a1.05 1.05 0 0 1 1.071-1.058H20.93Z" />,
  'CustomTranscriptOutlined',
);

export default CustomTranscriptOutlined;
